import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false }) // NProgress 配置

// 服务商业务路由必须在店铺申请审核通过后才能访问，不能只依赖侧边菜单隐藏。
const resolveProviderAccess = async (to, next) => {
	if (!to.path.startsWith('/provider')) {
		next()
		return
	}

	await store.dispatch('merchantShop/loadShopContext')
	const isApproved = store.getters.isMerchantShopApproved
	// 未取得店铺业务权限时，禁止通过手动输入地址访问店铺、商品、订单等受限页面。
	if (to.meta.requiresApprovedShop && !isApproved) {
		next({ path: '/provider/application', replace: true })
		return
	}
	// 审核通过后不再开放商家申请页面，直接引导用户进入“我的店铺”。
	if (to.name === 'ProviderApplication' && isApproved) {
		next({ path: '/provider/store', replace: true })
		return
	}
	next()
}

router.beforeEach((to, from, next) => {
	NProgress.start() // start progress bar
	// next()

	// 判定用户是否登录
	const hasToken = getToken()

	if (hasToken) {
		if (to.path === '/login') {
			next({ path: '/' })
			NProgress.done()
		} else {
			// 判定用户是否获取了用户信息
			const hasGetUserInfo = store.getters.realName
			if (hasGetUserInfo) {
				resolveProviderAccess(to, next)
			} else {
				store
					.dispatch('user/getUserInfo')
					.then(() => {
						resolveProviderAccess(to, next)
					})
					.catch(() => {
						store.dispatch('user/logout').then(() => {
							next(`/login?redirect=${to.path}`)
						})
					})
			}
		}
	} else {
		/* has no token*/
		if (to.path === '/login') {
			next()
		} else {
			if (to?.meta?.whiteListed) {
				next()
			} else {
				// 部分页面需要登录才能访问，没有登录的用户跳转到登录页面，登录成功后跳转到之前的页面
				// next(`/login?redirect=${to.path}`)
				next(`/login`)
			}
		}
		NProgress.done()
	}
})

router.afterEach(() => {
	NProgress.done() // finish progress bar
})
